<script>
  import AdGroupList from './components/AdGroupList.vue'
  import BannerList from './components/BannerList.vue'

  export default {
    name: 'FooterBannerList',
    components: {
      AdGroupList,
      BannerList
    },
    data() {
      return {
        activeName: 'adGroup'
      }
    },
    methods: {
      // 切换tab
      handleTabClick(tab) {
        console.log('当前选中的tab:', tab.name)
      }
    }
  }
</script>

<template>
  <div class="footer-banner-container">
    <el-tabs v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane label="广告组列表" name="adGroup">
        <!--        <AdGroupList />-->
      </el-tab-pane>

      <el-tab-pane label="Banner列表" name="banner">
        <!--        <BannerList />-->
      </el-tab-pane>
    </el-tabs>
    <AdGroupList v-if="activeName === 'adGroup'" />
    <BannerList v-else />
  </div>
</template>

<style scoped lang="scss">
  .footer-banner-container {
    padding: 20px;
  }
</style>
